
import AppEvents from 'app/lib/AppEvents';
import Constants from "app/lib/Constants";
import AppService from "app/lib/services/AppService";
import EventService from 'app/lib/services/EventService';
import LocalStorage from "app/lib/utils/LocalStorage";
import { AppContext } from 'components/shared/contexts/AppContext';
import { AuthContext } from 'components/shared/contexts/AuthContext';
import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Routes from './Routes';
import Button from "./shared/app/Button";
import Dialog from "./shared/app/Dialog";
import ErrorBoundary from './shared/app/ErrorBoundary';
import SideMenu from './shared/app/SideMenu';
import AppProvider from './shared/AppProvider';
import AuthProvider from './shared/AuthProvider';
// global styles
import './style.scss';

export default App = (props) => {
    const [showNewVersionDialog, setShowNewVersionDialog] = useState(false);

    // Todo: there should be a different global Module management component.
    // const accountDataModule = AccountDataModule;
    // const campaignsModule = CampaignsDataModule;
    // const shopifyModule = ShopifyDataModule;
    // const adspendModule = AdspendDataModule;

    useEffect(() => {
        const onError = event => onApiError(AppEvents.PROVIDER_API_ERROR, event);
        EventService.subscribe(AppEvents.API_ERROR, async (event) => onError);
        EventService.subscribe(AppEvents.PROVIDER_API_ERROR, async (event) => onError);
        EventService.subscribe(AppEvents.APP_VERSION_UPDATED, onAppNewVersion);

        return () => {
            EventService.unsubscribe(AppEvents.API_ERROR, onError);
            EventService.unsubscribe(AppEvents.PROVIDER_API_ERROR, onError);
            EventService.unsubscribe(AppEvents.APP_VERSION_UPDATED, onAppNewVersion);
        }
    }, []);

    const onApiError = (event) => {
        console.log(`onApiError`, event);
        if (event.target.error.message) {
            NotificationService.notifyError('API Error', event.target.error.message, { duration: 5 });
        }
    }

    const onAppNewVersion = (event) => {
        let disableAlert = LocalStorage.get(Constants.DISABLE_APP_VERSION_ALERTS);
        if (disableAlert == event.target.new) return; // if disabled version matches new, ignore
        setShowNewVersionDialog(true);
    }

    const onDisableVersionAlerts = () => {
        LocalStorage.set(Constants.DISABLE_APP_VERSION_ALERTS, AppService.getAppRunningVersion());
        setShowNewVersionDialog(false);
        console.log(`Alerts disabled.`)
    }

    const onLogout = async (auth) => {
        console.log(`Logging out...`, auth, props);
        setShowNewVersionDialog(false);
        await auth.logout();
    }

    const onContinue = () => {
        setShowNewVersionDialog(false);
    }

    const renderNewAppVersionDialog = (auth) => {
        return <Dialog open={true} title={`New Adaya Version`}
            body={
                <div className="body center">
                    A new version of the Adaya web applicaton has been published.
                    <br />
                    It is recommended that you logout and log back in to avoid unexpected errors.
                    <br />
                    Logout below, or continue to hide this warning and proceed.
                </div>
            }
            actions={[
                <Button key="logout" className="btn" round filled color="blue" onClick={() => onLogout(auth)}>Logout</Button>,
                <Button key="continue" className="btn" round color="blue" onClick={() => onContinue()}>Continue</Button>,
                <Button key="disable" className="btn" round color="blue" onClick={() => onDisableVersionAlerts()}>Disable alerts</Button>,
            ]}
            onClose={() => onContinue()} />
    }

    return (
        <AppProvider options={{}}>
            <AppContext.Consumer>
                {app => {

                    return (

                        <div id="app-container" className="layout">

                            <div id="modal-container" />

                            <ErrorBoundary>

                                <AuthProvider authOptions={{}}>
                                    <AuthContext.Consumer>
                                        {auth => {
                                            return (
                                                <BrowserRouter>

                                                    <SideMenu
                                                        {...props}
                                                        auth={auth}
                                                    />

                                                    <ErrorBoundary auth={auth}>

                                                        {showNewVersionDialog && renderNewAppVersionDialog(auth)}

                                                        <div className={'page-context ' + (auth.loggedIn ? 'expanded' : '')}>
                                                            {
                                                                // Show nothing(?) until initial libraries are loaded
                                                                !(auth.authFinished) ? <></>
                                                                    : <Routes {...props} auth={auth} />
                                                            }
                                                        </div>

                                                    </ErrorBoundary>

                                                </BrowserRouter>
                                            );

                                        }}
                                    </AuthContext.Consumer>
                                </AuthProvider>

                            </ErrorBoundary>

                        </div>

                    );

                }}

            </AppContext.Consumer>
        </AppProvider>
    );
};
